<template>
    <div class="card bs-5 mb-5">
        <div class="fl-te-c pb-3">
            <h4 v-html="'TESTIMONIALS'"></h4>
            <div>
                <btn color="success" icon="fa fa-plus" size="md" @click="$refs.testimonialsAddModal.show()" text="Add"/>
            </div>
        </div>
        <vue-table :fields="fields" :url="listUrl" :per-page="10" ref="table">
            <template #profile_img="{rowData}">
                <img :src="prefix + rowData.profile_img" width="150px" alt="img">
            </template>
            <template #disable="{rowData}">
                <checkbox-input v-model="rowData.disable" @input="disable(rowData)"></checkbox-input>
            </template>
            <template #actions="{rowData}">
                <div class="btn-group-tight">
                    <delete-btn @click="setDelete(rowData)"/>
                    <edit-btn @click="setEdit(rowData)"/>
                </div>
            </template>
        </vue-table>

        <modal title="Add Testimonial" ref="testimonialsAddModal" width="60r" :no-close-on-backdrop="true" header-color="primary">
            <AddTestimonials @success="formSuccess"></AddTestimonials>
        </modal>

        <modal title="Edit Testimonial" ref="testimonialsEditModal" :no-close-on-backdrop="true" width="60r" header-color="primary">
            <EditTestimonials :initial-data="editingItem" @success="formSuccess"></EditTestimonials>
        </modal>

        <delete-modal ref="testimonialsDeleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
            <p>You are about to delete the Testimonial <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
            </p>

            <template #loading>
                <loading-animation/>
                Please wait while we delete <b v-html="deletingItem && deletingItem.id"></b>.
            </template>
        </delete-modal>

    </div>
</template>

<script>
import urls from '../../../../data/urls';
import AddTestimonials from './AddTestimonials';
import EditTestimonials from './EditTestimonials';
import axios from 'secure-axios';

export default {
    name       : 'Testimonials',
    components : { AddTestimonials, EditTestimonials },
    data () {
        return {
            prefix       : '',
            listUrl      : urls.admin.event.testimonials.list,
            deleteUrl    : urls.admin.event.testimonials.delete,
            editingItem  : null,
            deletingItem : null,
            fields       : [
                {
                    name       : 'name',
                    sortField  : 'name',
                    title      : 'Name',
                    titleClass : ''
                },
                {
                    name       : 'place',
                    sortField  : 'place',
                    title      : 'Place',
                    titleClass : ''
                },
                {
                    name       : '__slot:profile_img',
                    sortField  : 'profile_img',
                    title      : 'Profile Image',
                    titleClass : ''
                },
                {
                    name       : 'comment',
                    sortField  : 'comment',
                    title      : 'Comment',
                    titleClass : ''
                },
                {
                    name       : '__slot:disable',
                    sortField  : 'disable',
                    title      : 'Disable',
                    titleClass : ''
                },
                {
                    name       : '__slot:actions',
                    title      : 'Actions',
                    titleClass : 'center aligned text-right',
                    dataClass  : 'aligned text-right'
                }
            ]
        };
    },
    methods : {
        formSuccess () {
            const refs = this.$refs;
            refs.testimonialsAddModal.close();
            refs.testimonialsEditModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.testimonialsEditModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.testimonialsDeleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$notify('Successfully Deleted Testimonial..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$refs.testimonialsDeleteModal.close();
            this.$refs.table.refreshTable();
        },

        disable (item) {
            const that = this;
            axios.form(urls.admin.event.testimonials.activateDeactivate, item).then(function (response) {
                const json = response.data;
                if (json.error === false) {
                    that.$notify(json.message, 'Success',
                        {
                            type : 'success'
                        });
                } else {
                    that.$notify(json.errors, 'Error',
                        {
                            type : 'warning'
                        });
                    item.disable = !item.disable;
                }
            }).catch(function (err) {
                item.disable = !item.disable;
                console.log('error : ', err);
                that.$notify('Something went wrong..!', 'Success',
                    {
                        type : 'warning'
                    });
            });
        }
    }
};
</script>

<style scoped>

</style>
